//@state
export interface homeState {
  home: boolean;
}

export const initialState: homeState = {
  home: true,
};
